import { useMutation, useQuery } from "@apollo/client";
import { CancelServiceOrderForm } from "components/forms";
import { Modal } from "components/layouts";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { wrapClick } from "utils";
import {
  CANCEL_PREMIUM_SERVICE_INTEREST,
  GET_PREMIUM_SERVICE_INTEREST,
} from "./apollo";

export default function CancelPremiumServiceInterestContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_PREMIUM_SERVICE_INTEREST, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    skip: !searchParams.id,
  });

  const [cancelPremiumServiceInterest] = useMutation(
    CANCEL_PREMIUM_SERVICE_INTEREST,
  );

  const item = data?.premiumServiceInterest;

  const form = useFormik({
    initialValues: {
      reason: "",
    },
    onSubmit: async (values) => {
      await cancelPremiumServiceInterest({
        variables: {
          id: searchParams.id,
          ...values,
        },
      }).then(({ data: result }) => {
        if (result?.cancelPremiumServiceInterest?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Premium Service Interest Cancelled Successfully",
            }),
          );
          form.resetForm();
          refetch?.();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not cancel Premium Service Interest",
            }),
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Cancel Premium Service Interest"
      description={
        item
          ? `Provide a reason for cancelling interest ${item.code} for ${item.customer?.fullName || "this customer"}.`
          : "Provide a reason for cancelling this premium service interest."
      }
      loading={loading}
      renderActions={() => (
        <>
          {item?.status === "Pending" ? (
            <button
              type="button"
              disabled={form.isSubmitting}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={wrapClick(form.handleSubmit)}
            >
              {form.isSubmitting ? "Cancelling..." : "Cancel Interest"}
            </button>
          ) : null}
        </>
      )}
    >
      {item?._id && item.status === "Pending" && (
        <CancelServiceOrderForm form={form} />
      )}
    </Modal>
  );
}
